export default __webpack_public_path__ + "static/media/3072.9e87c20d.png";